import { Component } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { environment } from 'environments/environment'; 
import { AuthService } from '../../_services';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../../_services/loader.service';



import { utils, write, WorkBook } from 'xlsx';  
import { saveAs } from 'file-saver'; 



import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;
declare var $: any; 



const distinctZone = data => data.filter((x, idx, xs) => xs.findIndex(y => y.Zone === x.Zone) === idx);
const distinctWard = data => data.filter((x, idx, xs) => xs.findIndex(y => y.Ward === x.Ward) === idx);
 
@Component({ 
  templateUrl: './driverVehicle.component.html', 
}) 
export class DriverVehicleComponent {
  search:any;
 public prjId:any
 public userId:any
 public startDate:any;
 public endDate:any;
 public defaultStartDate:any;
 public defaultEndDate:any;
 public dataRangeModal:any; 
 public showLoader: boolean;  
 currentDateModal:any

 driverData:any;
 

 

  public distinctZone: any[]
  public distinctWard: any[]
  constructor(private http : HttpClient ,private auth : AuthService,public routes: ActivatedRoute, public router: Router,private loaderService: LoaderService) {
    this.loaderService.status.subscribe((val: boolean) =>{
        this.showLoader = val;
      });
      var date = new Date();   
      this.currentDateModal=date;
    
    var date = new Date(); 
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    this.defaultStartDate = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate(); 
    this.defaultEndDate = (date.getFullYear()) + '-' + (date.getMonth()+1) + '-' + date.getDate(); 
    this.dataRangeModal= {beginDate: {year: firstDay.getFullYear(), month: firstDay.getMonth()+1, day: firstDay.getDate()}, endDate: {year: date.getFullYear(), month: date.getMonth()+1, day: date.getDate()}};
  }  


  importReport(vehVtsDailyList){
    const ws_name = 'VtsReport';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(vehVtsDailyList);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 
    'binary' });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'VtsReport.xlsx');
    }s2ab(s){
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xFF;
        };
        return buf;
    } 





  getDriverData(date){
    this.loaderService.display(true);
    this.http.get(environment.apiUrl + 'admin/getDriverVehicle?prjId=' + this.prjId + '&startDate=' + date).subscribe(data => {
      this.driverData = data
      this.loaderService.display(false);
      
      });
  }

  orgValueChange(date){ 
    this.getDriverData(date)
  }



  ngOnInit() 
  { 
    this.startDate = moment(new Date()).format('YYYY-MM-DD');
    this.prjId = this.auth.getAuthentication().projectId  
    this.userId = this.auth.getAuthentication().id 
    this.getDriverData(this.startDate)
  }

}


// WEBPACK FOOTER //
// ./src/app/reports/vtsReport/driverVehicle.component.ts